import { render, staticRenderFns } from "./GrcCMSRENDER.vue?vue&type=template&id=7b8ecf12&scoped=true&"
import script from "./GrcCMSRENDER.vue?vue&type=script&lang=js&"
export * from "./GrcCMSRENDER.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8ecf12",
  null
  
)

export default component.exports